module.exports = __webpack_public_path__ + "static/media/answer.64d0d351.mp3";